module.exports = __webpack_public_path__ + "static/Customcounsellormatchcardfrench-3dfde847d9dcd9e68fae3e52fbb92d4a.png";